<template>
    <div>
        <el-button type="text" icon="el-icon-upload2" @click="uploadInvoiceModal">上传发票</el-button>
        <vxe-table row-key row-id="id" ref="xTable1" :data="getinvoiceData">
            <!-- <vxe-table-column title="开票方名称" field="salerName"></vxe-table-column>
            <vxe-table-column title="开票方税号" field="salerTaxNo"></vxe-table-column> -->
            <vxe-table-column title="销货方名称" field="sallerName"></vxe-table-column>
            <vxe-table-column title="销货方纳税人识别号" field="sallerTaxNo"></vxe-table-column>
            <vxe-table-column title="购货方名称" field="buyerName"></vxe-table-column>
            <vxe-table-column title="购货方纳税人识别号" field="buyerTaxNo"></vxe-table-column>
            <vxe-table-column title="发票项目名称" field="invoiceItem"></vxe-table-column>
            <vxe-table-column title="发票代码" field="invoiceCode"></vxe-table-column>
            <vxe-table-column title="发票号码" field="invoiceNo"></vxe-table-column>
            <vxe-table-column title="价税合计(元)" field="totalAmount"></vxe-table-column>
            <vxe-table-column title="不含税总金额(元)" field="amount"></vxe-table-column>
            <vxe-table-column title="总税额" field="taxAmount"></vxe-table-column>
            <vxe-table-column title="税率（%）" field="taxRate"></vxe-table-column>
            <vxe-table-column title="发票流水号" field="serialNo"></vxe-table-column>
            <vxe-table-column title="发票日期" field="invoiceDate"></vxe-table-column>
            <vxe-table-column title="操作" width="200" align="center" show-overflow>
              <template #default="{ row }">
                <el-button type="text" size="mini" @click="handleRemove(row)"
                  >删除</el-button
                >
              </template>
            </vxe-table-column>
        </vxe-table>
        <div style="margin-top: 20px;display: flex;flex-direction: row;align-items: center;">
          <div><span style="color: red;">*</span>是否需要上传发票：</div>
          <el-select v-model="invoiceFlag" placeholder="是否需要上传发票" style="width: 160px;">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button type="danger" @click="onSubmit" size="small" icon="el-icon-check">保存</el-button>
            <el-button type="danger" @click="closeForm" size="small" icon="el-icon-close">关闭</el-button>
        </div>
        <Modal
        :modalConfig.sync="modalConfig"
        :visible.sync="modalConfig.visible"
        @onClose="closeModal"
        >
            <component
                :ref="formName"
                :is="formName"
                :formConfig="formConfigData"
                @closeModal="closeModal"
                @setinvoiceData="setinvoiceData"
            />
        </Modal>
    </div>
</template>
<script>
import { Loading } from 'element-ui';
import Modal from '../../../../components/modal';
import InvoiceModal from './invoice_modal.vue';
import request from '../../../../utils/request';

export default {
  name: 'invoice_table',
  props: {
    formConfig: Object,
  },
  data() {
    return {
      modalConfig: {
        title: '标题',
        type: 'Full',
        visible: false,
      },
      formConfigData: {},
      formName: 'InvoiceModal',
      getinvoiceData: [],
      options: [
        {
          value: 'Y',
          label: '是',
        },
        {
          value: 'N',
          label: '否',
        },
      ],
      invoiceFlag: '',
    };
  },
  components: {
    Modal,
    InvoiceModal,
  },
  created() {},
  methods: {
    setinvoiceData(val) {
      const data = (val.data || []).map((v) => {
        const obj = v;
        obj.objectId = this.formConfig.bussinesId;
        obj.id = '';
        return obj;
      });
      const newList = [];
      if (this.getinvoiceData && this.getinvoiceData.length > 0) {
        this.getinvoiceData.forEach((v) => {
          data.forEach((k) => {
            if (v.invoiceNo !== k.invoiceNo && v.invoiceCode !== k.invoiceCode) {
              newList.push(...v);
            }
          });
        });
        this.getinvoiceData.push(...newList);
        // this.getinvoiceData.push(...data);
      } else {
        this.getinvoiceData = data;
      }
    },
    closeModal() {
      this.modalConfig.visible = false;
    },
    handleRemove(row) {
      const index = this.getinvoiceData.findIndex((a) => a.invoiceNo === row.invoiceNo && a.invoiceCode === row.invoiceCode);
      this.getinvoiceData.splice(index, 1);
    },
    // 上传发票
    uploadInvoiceModal() {
      this.formName = 'InvoiceModal';
      this.modalConfig.title = '上传发票';
      this.modalConfig.visible = true;
      this.modalConfig.type = 'full';
      this.formConfigData = this.formConfig;
    },
    onSubmit() {
      if (!this.invoiceFlag) {
        this.$message.error('请选择是否需要上传发票');
        return;
      }
      const loadingInstance = Loading.service({
        fullscreen: true,
        text: '加载中...',
        background: 'rgba(0, 0, 0, 0.8)',
      });
      request.post('/tpm/tpmscaninvoice/saveApprovedByInvoice', {
        businessId: this.formConfig.bussinesId,
        invoiceFlag: this.invoiceFlag,
      }).then((peres) => {
        if (peres.success) {
          if (this.invoiceFlag === 'Y') {
            request
              .post('/tpm/tpmscaninvoice/saveByList', this.getinvoiceData)
              .then((res) => {
                if (res.success) {
                  this.$nextTick(() => {
                    loadingInstance.close();
                  });
                  this.$emit('onClose');
                  this.$message.success('保存成功');
                } else {
                  this.$nextTick(() => {
                    loadingInstance.close();
                  });
                }
              }).catch((err) => {
                this.$nextTick(() => {
                  loadingInstance.close();
                });
              });
          } else {
            this.$nextTick(() => {
              loadingInstance.close();
            });
            this.$emit('onClose');
            this.$message.success('保存成功');
          }
        }
      }).catch((err) => {
        this.$nextTick(() => {
          loadingInstance.close();
        });
      });
    },
    closeForm() {
      this.$emit('onClose');
    },
  },
};
</script>
